/**
 * ScreenConnector manages when to display a screen.
 *
 * Screens are modal interfaces that are always full screen
 * and reserve the application (only one screen at a time), but can be summoned from anywhere and do not
 * affect navigation path or the flow of main navigation. If you don't need to reserve the application or
 * multiple instances can be active at once you should use a modal instead.
 */
import { closeScreen, ScreenPayloadInterface } from 'client/components/Screen/ScreenActions'
import { StateInterface } from 'client/Interfaces/StateInterface'
import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { ImportScreen } from './ImportScreen/ImportScreen'
import './Screen.scss'

// Import all possible screens to the connector and export their names as types
export const Screens = {
  Import: ImportScreen,
}
// eslint-disable-next-line no-redeclare
export type Screens = keyof typeof Screens

export const selectScreen = (state: StateInterface) => {
  return state.navigation.screen as ScreenPayloadInterface<Screens, any>
}

// Map and export dispatch types for individual screens to use
export const mapDispatchToProps = (dispatch) => {
  return {
    close: () => {
      return dispatch(closeScreen())
    },
    action: (payload) => {
      return dispatch(payload)
    },
    dispatch,
  }
}
export type ConnectedScreenProps = ReturnType<typeof mapDispatchToProps>

export const ScreenConnector = () => {
  const dispatch = useDispatch()
  const screen = useSelector(selectScreen)
  if (!screen) {
    return null
  }

  return React.createElement(Screens[screen.name], {
    ...mapDispatchToProps(dispatch),
    ...screen.props,
  })
}
